<template>
    <router-view></router-view>
</template>

<script>
    export default {
        props: {
        },
        components: {
        },
        mounted() {
        },
        setup(props) {
        }
    }
</script>
